import {
  mockContributorsData,
  mockPublishersData,
  mockShareholdersData,
  mockTrackCostsData,
} from "../../data/mockData/trackMetadataData";
import { types } from "./action";

const initialState = {
  contributors: { seed: mockContributorsData, tableRowResults: [], created: [] },
  publishers: { seed: mockPublishersData, tableRowResults: [], created: [] },
  shareholders: { seed: mockShareholdersData, tableRowResults: [], created: [] },
  trackCosts: { seed: mockTrackCostsData, tableRowResults: [], created: [] },
};

const knownKeys = {
  contributors: true,
  publishers: true,
  shareholders: true,
  trackCosts: true,
};

function upsertById(rows, row) {
  if (!row || row.id == null) {
    return rows;
  }
  const sid = String(row.id);
  const idx = rows.findIndex(i => String(i.id) === sid);
  if (idx >= 0) {
    const next = [...rows];
    next[idx] = { ...next[idx], ...row };
    return next;
  }
  return [...rows, row];
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_TRACK_METADATA: {
      const payload = action.payload || {};
      const nextState = { ...state };
      Object.keys(payload).forEach(key => {
        if (!knownKeys[key]) {
          return;
        }
        const rows = payload[key];
        nextState[key] = {
          ...state[key],
          tableRowResults: Array.isArray(rows) ? rows : state[key].tableRowResults,
        };
      });
      return nextState;
    }
    case types.ADD_TRACK_METADATA_ITEM: {
      const payload = action.payload || {};
      const { key, row } = payload;
      if (!knownKeys[key]) {
        return state;
      }
      return {
        ...state,
        [key]: {
          ...state[key],
          created: upsertById(state[key].created, row),
        },
      };
    }
    default:
      return state;
  }
};
